import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import { DeployedCodeAlertIcon } from "@/components/uis/CustomIcon/DeployedCodeAlertIcon";
import type { Types } from "./types";
const width = "28px";
const height = "28px";
export const iconController = ({
  type,
  iconColor
}: {
  type: Types;
  iconColor?: "primary";
}) => {
  switch (type) {
    case "inspector":
      return <SupervisorAccountOutlinedIcon width={width} height={height} color={iconColor} />;
    case "berth":
      return <LocationOnOutlinedIcon width={width} height={height} color={iconColor} />;
    case "assessmentList":
      return <SummarizeOutlinedIcon width={width} height={height} color={iconColor} />;
    case "composition":
      return <ContentPasteSearchIcon width={width} height={height} color={iconColor} />;
    case "impurity":
      return <DeployedCodeAlertIcon width={width} height={height} color={iconColor} />;
    case "impurityRegister":
      return <AddOutlinedIcon width={width} height={height} color={iconColor} />;
    case "impurityList":
      return <SummarizeOutlinedIcon width={width} height={height} color={iconColor} />;
    case "impuritySaveList":
      return <SummarizeOutlinedIcon width={width} height={height} color={iconColor} />;
    case "logout":
      return <LogoutOutlinedIcon width={width} height={height} color={iconColor} />;
    case "carNumber":
      return <LocalShippingOutlinedIcon width={width} height={height} color={iconColor} />;
    case "trader":
      return <CorporateFareIcon width={width} height={height} color={iconColor} />;
    case "recycler":
      return <EmojiTransportationIcon width={width} height={height} color={iconColor} />;
    case "scrapCategory":
      return <CategoryOutlinedIcon width={width} height={height} color={iconColor} />;
    case "assessmentDate":
      return <CalendarMonthIcon width={width} height={height} color={iconColor} />;
    case "assessmentStartTime":
      return <HourglassTopIcon width={width} height={height} color={iconColor} />;
    case "assessmentStopTime":
      return <HourglassBottomIcon width={width} height={height} color={iconColor} />;
    case "scrapCategorySelectedAt":
      return <EditCalendarIcon width={width} height={height} color={iconColor} />;
    case "camera":
      return <VideocamOutlinedIcon width={width} height={height} color={iconColor} />;
    case "remoteAssessment":
      return <RssFeedIcon width={width} height={height} color={iconColor} />;
    case "period":
      return <CalendarMonthIcon width={width} height={height} color={iconColor} />;
    default:
      throw new Error(`type:${type} is invalid `);
  }
};